// src/App.js - VERSÃO FINAL
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import MainLayout from './components/Layout/MainLayout';
import Login from './components/Login';
import LinhaTempo from './pages/LinhaTempo';
import Produtividade from './pages/Produtividade';
import RelatorioTabular from './pages/RelatorioTabular';
import RelatorioCapsulas from './pages/RelatorioCapsulas';
import RelatorioSaches from './pages/RelatorioSaches';
import Configuracoes from './pages/Configuracoes';
import ImpressaoCracha from './pages/ImpressaoCracha';
import Requisicoes from './pages/Requisicoes';
import RelatorioProducaoOrdem from './pages/RelatorioProducaoOrdem';
import OrdemProducao from './pages/OrdemProducao';
import ConferenciaFarma from './pages/ConferenciaFarma';
import DivergenciasFarma from './pages/DivergenciasFarma';
import Producao from './pages/Producao';
import ControleFicha from './pages/ControleFicha';
import { CircularProgress, Box } from '@mui/material';

const LoadingScreen = () => <Box display="flex" justifyContent="center" alignItems="center" height="100vh"><CircularProgress /></Box>;

const ProtectedRoute = ({ children, requiredLevel = 1 }) => {
  const { user, loading, hasPermission } = useAuth();
  if (loading) return <LoadingScreen />;
  // Só permite acesso se o usuário existir e tiver id válido
  if (!user || typeof user.id === 'undefined' || user.id === null) {
    localStorage.removeItem('user');
    return <Navigate to="/login" replace />;
  }
  if (!hasPermission(requiredLevel)) return <Navigate to="/linha-tempo" replace />;
  return children;
};

const LayoutWithOutlet = () => (
  <MainLayout>
    <Outlet />
  </MainLayout>
);

const AppRoutes = () => {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;

  return (
    <Routes>
      <Route path="/login" element={!user ? <Login /> : <Navigate to="/linha-tempo" replace />} />
      <Route path="/" element={user ? <LayoutWithOutlet /> : <Navigate to="/login" replace />}>
        <Route index element={<Navigate to="/linha-tempo" replace />} />
        <Route path="linha-tempo" element={<ProtectedRoute requiredLevel={1}><LinhaTempo /></ProtectedRoute>} />
        {/* LAB (nível 2) visualiza apenas Produção, Controle de Ficha e Linha do Tempo */}
        <Route path="producao" element={<ProtectedRoute requiredLevel={2}><Producao /></ProtectedRoute>} />
        <Route path="controle-ficha" element={<ProtectedRoute requiredLevel={2}><ControleFicha /></ProtectedRoute>} />
        {/* Todo o restante é exclusivo de administradores (nível 3) */}
        <Route path="produtividade" element={<ProtectedRoute requiredLevel={3}><Produtividade /></ProtectedRoute>} />
        <Route path="relatorio-tabular" element={<ProtectedRoute requiredLevel={3}><RelatorioTabular /></ProtectedRoute>} />
        <Route path="relatorio-capsulas" element={<ProtectedRoute requiredLevel={3}><RelatorioCapsulas /></ProtectedRoute>} />
        <Route path="relatorio-saches" element={<ProtectedRoute requiredLevel={3}><RelatorioSaches /></ProtectedRoute>} />
        <Route path="requisicoes" element={<ProtectedRoute requiredLevel={3}><Requisicoes /></ProtectedRoute>} />
        <Route path="ordem-producao" element={<ProtectedRoute requiredLevel={3}><OrdemProducao /></ProtectedRoute>} />
        <Route path="relatorio-producao-ordem" element={<ProtectedRoute requiredLevel={3}><RelatorioProducaoOrdem /></ProtectedRoute>} />
        <Route path="conferencia-farma" element={<ProtectedRoute requiredLevel={3}><ConferenciaFarma /></ProtectedRoute>} />
        <Route path="divergencias-farma" element={<ProtectedRoute requiredLevel={3}><DivergenciasFarma /></ProtectedRoute>} />
        {/* Funcionários, Setores e Cadastro de Usuários migraram para abas de Configurações */}
        <Route path="funcionarios" element={<Navigate to="/configuracoes" replace />} />
        <Route path="setores" element={<Navigate to="/configuracoes" replace />} />
        <Route path="usuarios" element={<Navigate to="/configuracoes" replace />} />
        <Route path="impressao-cracha" element={<ProtectedRoute requiredLevel={3}><ImpressaoCracha /></ProtectedRoute>} />
        <Route path="configuracoes" element={<ProtectedRoute requiredLevel={3}><Configuracoes /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<Navigate to={user ? "/linha-tempo" : "/login"} replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
